import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useCallback } from 'react';
import { Box } from '@mui/material';
import { Plus } from 'lucide-react';
import { useSelector } from 'react-redux';
import PagesCommonHeader from '../../../common_components/PagesCommonHeader';
import AppButton from '../../../common_components/AppButton';
import { Dropdown } from '../../../common_components/FormInputs';
import { selectDesignationWiseUsers } from '../../../redux/clientDataSlice';
import { selectAgendaVisibleClients, selectAgendaVisibleClientsLoading, } from '../../../redux/meetingAgendaSlice';
import { AM_DESIGNATIONS, collectUsersByDesignations, } from '../../../utils/designationFilters';
/**
 * Meeting Agenda — filter bar (Phase 2).
 *
 * Client options come from /api/visible-clients under the meeting_agenda
 * module key, so client_scope already decides whether that's the user's
 * assigned paid-media clients or all of them — nothing to branch on here.
 *
 * The AM dropdown is a "Full Access" capability, using the same designation
 * source as the Clients page. It is only rendered with that action, and the
 * server ignores am_id without it either way.
 */
const labeledValue = (label, value) => (_jsxs("span", { children: [_jsxs("span", { style: { color: '#101828', fontWeight: 500 }, children: [label, ":"] }), ' ', _jsx("span", { style: { color: '#667085' }, children: value })] }));
const MeetingAgendaHeader = ({ clientId, setClientId, amId, setAmId, showAmFilter, onNewAgenda, }) => {
    const designationWiseUsers = useSelector(selectDesignationWiseUsers);
    const visibleClients = useSelector(selectAgendaVisibleClients);
    const clientsLoading = useSelector(selectAgendaVisibleClientsLoading);
    const accountManagers = useMemo(() => collectUsersByDesignations(designationWiseUsers?.designationMap, AM_DESIGNATIONS), [designationWiseUsers]);
    const amOptions = useMemo(() => [
        { value: '', label: 'All' },
        ...accountManagers.map((u) => ({
            value: u._id,
            label: `${u.first_name || ''} ${u.last_name || ''}`.trim(),
        })),
    ], [accountManagers]);
    const clientOptions = useMemo(() => [
        { value: '', label: 'All' },
        ...(visibleClients || []).map((c) => ({
            value: String(c._id),
            label: c.name,
        })),
    ], [visibleClients]);
    const labelFor = (options, value) => options.find((o) => o.value === value)?.label || 'All';
    const handleSingle = useCallback((setter) => (val) => setter(val), []);
    return (_jsx(PagesCommonHeader, { height: "58px", title: "Meeting Agenda", rightSection: _jsxs(Box, { display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap", children: [showAmFilter && (_jsx(Dropdown, { value: amId, onChange: handleSingle(setAmId), options: amOptions, placeholder: "AM: All", displayValue: labeledValue('AM', labelFor(amOptions, amId)), leftIcon: "/assets/userC.svg", size: "sm", fullWidth: false, className: "header-dropdown", searchable: accountManagers.length > 10 })), _jsx(Dropdown, { value: clientId, onChange: handleSingle(setClientId), options: clientOptions, placeholder: "Client: All", displayValue: labeledValue('Client', labelFor(clientOptions, clientId)), leftIcon: "/assets/userC.svg", size: "sm", fullWidth: false, className: "header-dropdown", loading: clientsLoading, searchable: clientOptions.length > 10 }), _jsx(AppButton, { variant: "contained", startIcon: _jsx(Plus, { size: 16 }), onClick: onNewAgenda, className: "all-Font-Sizes", sx: {
                        bgcolor: '#EE2A7B',
                        textTransform: 'none',
                        whiteSpace: 'nowrap',
                        '&:hover': { bgcolor: '#D91F6A' },
                    }, children: "New Agenda" })] }) }));
};
export default MeetingAgendaHeader;
